export var TrackKind;
(function (TrackKind) {
    TrackKind["Video"] = "Video";
    TrackKind["Audio"] = "Audio";
    TrackKind["ScreenshareVideo"] = "ScreenshareVideo";
    TrackKind["ScreenshareAudio"] = "ScreenshareAudio";
    TrackKind["LocalVideo"] = "LocalVideo";
})(TrackKind || (TrackKind = {}));
var Track = /** @class */ (function () {
    function Track(_participant, _isLocalTrack, _trackKind, _track) {
        this.isLocalTrack = false;
        this.extraData = {};
        this.trackId = _participant.userId + _trackKind.toString();
        this.isLocalTrack = _isLocalTrack;
        this.trackKind = _trackKind;
        this.track = _track;
        this.participant = _participant;
    }
    Track.prototype.updateTrackWithNewData = function (track) {
        this.participant = track.participant;
        this.extraData = track.extraData;
        this.track = track.track;
    };
    return Track;
}());
export { Track };
